import axios from "axios"
var domianURL = window._CONFIG['domianURL']
    // var domianURL = "http://192.168.0.115:9000/smart-team-building/"
var staticDomainURL = domianURL.replace(/\/+$/, '') + "/sys/common/static/"
export function getFileAccessHttpUrl(url, base = staticDomainURL) {
    if (typeof url !== 'string' || !url) return ''
    url = url.trim()
    if (!url) return ''
    if (/^(https?:)?\/\/[^/]|^blob:/i.test(url)) return url
    if (/^data:image\/(png|jpe?g|gif|webp|bmp);base64,[a-z0-9+/]+={0,2}$/i.test(url)) return url
    if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return ''
    return base.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '')
}

axios.defaults.baseURL = domianURL //正式

// 请求超时
axios.defaults.timeout = 60000;
// 请求头
// 'X-Access-Token': token,
// "Accept": "application/json"
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8';
// 先导入vuex,因为我们要使用到里面的状态对象
// vuex的路径根据自己的路径去写
import store from '@/store/index';
import de from "element-ui/src/locale/lang/de";

// 请求拦截器
axios.interceptors.request.use(
        config => {
            // 每次发送请求之前判断vuex中是否存在token
            // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
            // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
            const token = store.state.token;
            // token && (config.headers['X-Access-Token'] = '111111');
            config.headers['X-Access-Token'] = '111111'
            if (config.method === 'get') {
                config.data = {
                        unused: 0
                    } // 这个是关键点,传一个无用的data否则请求头'content-type'会没掉
            }
            return config;
        },
        error => {
            return Promise.error(error);
        })
    // 响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况

    // 根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                    break;

                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    Toast({
                        message: '登录过期，请重新登录',
                        duration: 1000,
                        forbidClick: true
                    });
                    // 清除token
                    localStorage.removeItem('token');
                    store.commit('loginSuccess', null);
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;

                    // 404请求不存在
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    Toast({
                        message: error.response.data.message,
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function httpGet(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}
export function httpTokenGet(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
            headers: {
                'X-Access-Token': this.$store.state.token,
                'Content-Type': 'application/json; charset=UTF-8'
            }
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}
export function httpPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function httpTokenPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
                header: {
                    'X-Access-Token': this.$store.state.token,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function httpPut(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function httpTokenPut(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, {
                params: params
            }, {
                header: {
                    'X-Access-Token': this.$store.state.token,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function httpDelete(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
                params: params,
                headers: {
                    'X-Access-Token': this.$store.state.token,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function onScrollT() {
    if (window.pageXOffset !== undefined) { // 所有浏览器，除了 IE9 及更早版本
        // window.pageYOffset = 0;
    } else { // IE9 及更早版本
        document.documentElement.setAttribute('scrollTop', 0)
        document.body.setAttribute('scrollTop', 0)
    }

}
export {
    staticDomainURL,
}
